import Phaser from "phaser";
import { GameConfig } from "./game/GameConfig";

// Initialize the game
new Phaser.Game(GameConfig);
